<script>
export let showIcon = true;
export let image;
export let heading;
export let content;
export let phone;
export let fax = null;
export let map = null;
export let email = null;
</script>

<div class="contact-card">
  <div class="image"><img src="{image}" alt="kontakt-order" /></div>

  <h3>
    {#if showIcon}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="23"
        viewBox="0 0 17 23"
        fill="none"
      >
        <path
          d="M8.5 1.5C4.634 1.5 1.5 4.634 1.5 8.5C1.5 13.5 8.5 21.5 8.5 21.5C8.5 21.5 15.5 13.5 15.5 8.5C15.5 4.634 12.366 1.5 8.5 1.5ZM8.5 11C7.119 11 6 9.881 6 8.5C6 7.119 7.119 6 8.5 6C9.881 6 11 7.119 11 8.5C11 9.881 9.881 11 8.5 11Z"
          stroke="#333333"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg>
    {/if}
    {heading}
  </h3>

  {@html content}

  {#if map}
    <p class="map">
      <a href="{map}" target="_blank">Hitta hit
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
          stroke="#2751BC"
          stroke-width="2"
          stroke-linecap="round"
        >
          <path d="M12.5 1.00012L17.5 1V6"></path>
          <path d="M16.5 2L9.5 9"></path>
          <path
            d="M7.5 3H3.5C2.39543 3 1.5 3.89543 1.5 5V15C1.5 16.1046 2.39543 17 3.5 17H13.5C14.6046 17 15.5 16.1046 15.5 15V11"
          ></path>
        </svg>
      </a>
    </p>
  {/if}

  <p><strong>Telefon:</strong> <a href="tel:{phone}">{phone}</a></p>

  {#if email}
    <p><strong>E-post:</strong> <a href="mailto:{email}">{email}</a></p>
  {/if}
  {#if fax}
    <p><strong>Fax:</strong> {fax}</p>
  {/if}
</div>
